<template>
    <div id="recordList">
        <div class="header">
            <!-- 面包屑导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>充值记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 搜索和添加 -->
        <div class="searchBox">
            <el-form :inline="true" style="margin-top: 20px">
                <el-form-item>
                    <el-input size="small" v-model="nickName" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size="small" v-model="rechargeNo" placeholder="请输入充值编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="timeDate" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="timestamp">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="btnSearch">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-upload" @click="btnExport">导出</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="content">
            <!-- 充值记录列表 -->
            <el-table size="small" :data="recordList" highlight-current-row border element-loading-text="拼命加载中"
                style="width: 100%" height="100%" v-horizontal-scroll>
                <el-table-column align="center" type="index" label="序号"></el-table-column>
                <el-table-column align="center" show-overflow-tooltipable prop="nickName" label="昵称"
                    width="160px"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="mobile" label="联系方式"
                    width="160px"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="rechargeNo" label="充值单号"
                    width="230px"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="createdTime" label="充值时间">
                    <template slot-scope="scope">
                        <div>{{ transformDate(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <div class="pageTurning">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>

<script>
import { rechargeRecordsApi, exportRechargeApi } from "@/api/registration";
import Pagination from "../../components/Pagination";
export default {
    data() {
        return {
            // 分页参数
            pageparm: {
                currentPage: 0,
                pageSize: 20,
                total: 10,
            },
            recordList: [],
            nickName: "", // 报名姓名
            mobile: "", // 报名手机号
            rechargeNo: "", // 订单号
            timeDate: '', // 时间范围
        };
    },
    created() {
        this.rechargeData();
    },
    // 注册组件
    components: {
        Pagination,
    },
    methods: {
        // 点击搜索
        btnSearch() {
            console.log(this.timeDate, '时间范围')
            this.pageparm.currentPage = 0
            this.rechargeData();
        },
        // 分页插件事件
        callFather(parm) {
            this.pageparm.currentPage = parm.currentPage;
            this.rechargeData();
        },
        // 导出
        btnExport() {
            let that = this

            this.$confirm("是否导出充值记录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.exportRecordData()
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消",
                });
            });
        },
        // 导出记录
        exportRecordData() {
            let that = this
            window.location.href = `http://118.195.249.109:446/app-yijiu-backstage/exportRechargeRecordListExcel?token=${localStorage.getItem("logintoken")}&nickName=${that.nickName}&page=${this.pageparm.currentPage}&mobile=${that.mobile}&rechargeNo=${that.rechargeNo}`
        },
        // 充值记录
        rechargeData() {
            let that = this;
            rechargeRecordsApi({
                page: that.pageparm.currentPage,
                nickName: that.nickName,
                mobile: that.mobile,
                rechargeNo: that.rechargeNo,
                startTime: that.timeDate ? that.timeDate[0]/1000 : '', // 开始时间
                endTime: that.timeDate ? that.timeDate[1]/1000 : '', // 结束时间
            }).then((res) => {
                if (res.code == 200) {
                    that.recordList = res.data.data;
                    console.log(that.recordList, "记录列表");
                    that.pageparm.total = res.data.count;
                } else {
                    return;
                }
            });
        },
    },
};
</script>

<style scoped>
.el-input__inner {
    height: 34px;
    padding-top: 0;
    padding-bottom: 0;
}

#recordList {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#recordList .header {
    flex: none;
}

#recordList .searchBox {
    flex: none;
}

#recordList .content {
    flex: auto;
}

#recordList .pageTurning {
    flex: none;
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/registration_admin/recharge_record.vue